module.exports = __webpack_public_path__ + "static/img/ket-renewal-mobile-sub-01@t.69ab3ac.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/ket-renewal/ket-renewal-mobile-sub-01@t.png
// module id = f7GB
// module chunks = 0